import { render, staticRenderFns } from "./Coupang.vue?vue&type=template&id=12108035&"
import script from "./Coupang.vue?vue&type=script&lang=js&"
export * from "./Coupang.vue?vue&type=script&lang=js&"
import style0 from "./Coupang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports